import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import ProductActions from "./components/ProductActions/ProductActions";
import ProductTable from "./components/ProductTable/ProductTable";

const PRODUCT_PAGE_TITLE = "Quản lý Mặt hàng";

const ProductWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: PRODUCT_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <ProductActions handleSearch={handleSearch} params={params} />
          <ProductTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default ProductWebLayout;
